module.exports = __webpack_public_path__ + "static/poweramp-8050e843748f64011596b47a1f2990a9.jpg";